import React from "react";

export const AcceptedCheckMarkIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M9.00016 16.6701L4.83016 12.5001L3.41016 13.9101L9.00016 19.5001L21.0002 7.50009L19.5902 6.09009L9.00016 16.6701Z"
      fill="#2E2E36"
    />
  </svg>
);
